// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66824a72","239":"41d19f12","455":"a0dae4b5"}[chunkId] + ".chunk.js";
};